import Styles from './TrackedChangeMetadata.module.scss'
import dayjs from 'dayjs'
import { dateFormat } from 'utils/dates'
import { LayerChange } from 'providers/LayerChangesProvider/types'
import { Profile } from 'types'
import { TrackedChangeIconWithTooltip } from 'components/TrackedChange/TrackedChangeItem/TrackedChangeIcon'

interface Props {
  trackedChange: LayerChange
  user?: Profile
}

export const TrackedChangeMetadata = ({ trackedChange, user }: Props) => (
  <>
    <TrackedChangeIconWithTooltip type={trackedChange.type} user={user} />
    <span className={Styles.dateTime}>
      {dayjs(trackedChange.createdAt).format(`${dateFormat(trackedChange.createdAt)} h:mm a`)}
    </span>
  </>
)
